import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";
import e from "prop-types";

var n = function n(e) {
  var t = function t() {
    for (var n = [], t = arguments.length; t--;) {
      n[t] = arguments[t];
    }

    return e.propType.apply(e, n);
  };

  return t.__meta = Object.assign({}, e, {
    toString: function toString() {
      return function e(n) {
        var t = n.__meta;
        if (!t) return "unknown";
        var r = t.type.name;
        return "arrayOf" === r ? "[" + e(t.type.value) + "]" : "objectOf" === r ? "{" + e(t.type.value) + "}" : "shape" === r || "exact" === r ? "{ " + Object.entries(t.type.value).map(function (n) {
          return n[0] + ": " + e(n[1]);
        }).join(" , ") + " }" : "union" === r ? "" + t.type.value.map(function (n) {
          return e(n);
        }).join(" | ") : "enum" === r ? "" + t.type.value.map(function (e) {
          return e.value;
        }).join(" | ") : r;
      }(t);
    }
  }), Object.defineProperties(t, {
    isRequired: {
      get: function get() {
        return n(Object.assign({}, e, {
          propType: e.propType.isRequired,
          required: !0
        }));
      }
    },
    defaultTo: {
      get: function get() {
        return function (t) {
          return n(Object.assign({}, e, {
            defaultValue: {
              value: String(t)
            }
          }));
        };
      }
    },
    desc: {
      get: function get() {
        return function (t) {
          return n(Object.assign({}, e, {
            description: t
          }));
        };
      }
    }
  }), t;
},
    t = function t(e, _t, r) {
  void 0 === r && (r = {});
  var u = r.value;
  return void 0 === u && (u = null), n({
    propType: e,
    type: {
      name: _t,
      value: u
    },
    required: !1,
    defaultValue: void 0
  });
},
    r = function r(e) {
  return Object.keys(e).reduce(function (n, t) {
    var r;
    return Object.assign({}, n, ((r = {})[t] = e[t].__meta, r));
  }, {});
},
    u = t(e.array, "array"),
    a = t(e.bool, "boolean"),
    o = t(e.func, "function"),
    i = t(e.number, "number"),
    c = t(e.object, "object"),
    f = t(e.string, "string"),
    p = t(e.symbol, "symbol"),
    l = t(e.any, "any"),
    s = function s(n) {
  return t(e.arrayOf(n), "arrayOf", {
    value: n
  });
},
    y = t(e.element, "element"),
    v = t(e.elementType, "elementType"),
    m = function m(n) {
  return t(e.instanceOf(n), "instanceOf", {
    value: n
  });
},
    b = t(e.node, "node"),
    O = function O(n) {
  return t(e.objectOf(n), "objectOf", {
    value: n
  });
},
    d = function d(n) {
  return t(e.oneOf(n), "enum", {
    value: n.map(function (e) {
      return {
        value: e
      };
    })
  });
},
    j = function j(n) {
  return t(e.oneOfType(n), "union", {
    value: n
  });
},
    g = function g(n) {
  return t(e.shape(n), "shape", {
    value: n
  });
},
    T = function T(n) {
  return t(e.exact(n), "exact", {
    value: n
  });
},
    h = {
  array: u,
  bool: a,
  func: o,
  number: i,
  object: c,
  string: f,
  symbol: p,
  any: l,
  arrayOf: s,
  element: y,
  elementType: v,
  instanceOf: m,
  node: b,
  objectOf: O,
  oneOf: d,
  oneOfType: j,
  shape: g,
  exact: T,
  getMetadata: r,
  checkPropTypes: e.checkPropTypes,
  resetWarningCache: e.resetWarningCache
};

h.PropTypes = h;
export default h;
export { r as getMetadata, u as array, a as bool, o as func, i as number, c as object, f as string, p as symbol, l as any, s as arrayOf, y as element, v as elementType, m as instanceOf, b as node, O as objectOf, d as oneOf, j as oneOfType, g as shape, T as exact };